/** One CSV cell. Text that a spreadsheet would run as a formula is prefixed with `'`; numbers pass through unchanged. */
function cell(v: string | number | null | undefined): string {
  if (v === null || v === undefined) return "";
  if (typeof v === "number") return String(v);
  const safe = /^[=+\-@\t\r]/.test(v) ? `'${v}` : v;
  return /[",\r\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

export const toCsv = (rows: ReadonlyArray<ReadonlyArray<string | number | null | undefined>>) => rows.map((r) => r.map(cell).join(",")).join("\r\n");

export function downloadCsv(filename: string, csv: string) {
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/** Follows `nextCursor` to the end, so an export is the whole filtered list and not its first page. */
export async function allPages<T>(fetchPage: (cursor: string | undefined) => Promise<{ rows: T[]; next: string | null }>): Promise<T[]> {
  const out: T[] = [];
  for (let cursor: string | undefined; ;) {
    const page = await fetchPage(cursor);
    out.push(...page.rows);
    if (!page.next) return out;
    cursor = page.next;
  }
}
